export default {"src":"/kaimono/_next/static/media/loading.e4ad2098.svg","height":124,"width":120};